<section class="grid grid-cols-sm 2xl:grid-cols-lg gap-5 py-0 px-5">
	<slot />
</section>
